import { createApp } from "vue";
import ElementPlus from 'element-plus'; 
import pinia from "./store";
import router from "./router";
import App from "./setup/Layout/App.vue";
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import AOS from 'aos'
import 'aos/dist/aos.css'

import "@/assets/icon/iconPark.js";
import "@/assets/icon/iconfont.js";

import "@/framework/GlobalCss";
import registerPlugins from "@/framework/Plugins";
import registerComponents from "@/framework/Components";


const app = createApp(App);
// app.use(components);
app.use(ElementPlus);
app.use(router);
app.use(pinia);
registerPlugins(app);
registerComponents(app);
app.mount("#app");
AOS.init({
  offset: 200,
  duration: 600,  
  delay: 0,
  once:false,
})